export const FETCH_PRODUCT_TYPES_REQUEST = 'FETCH_PRODUCT_TYPES_REQUEST';
export const FETCH_PRODUCT_TYPES_SUCCESS = 'FETCH_PRODUCT_TYPES_SUCCESS';
export const FETCH_PRODUCT_TYPES_FAILURE = 'FETCH_PRODUCT_TYPES_FAILURE';

export const ADD_PRODUCT_TYPE_REQUEST = 'ADD_PRODUCT_TYPE_REQUEST';
export const ADD_PRODUCT_TYPE_SUCCESS = 'ADD_PRODUCT_TYPE_SUCCESS';
export const ADD_PRODUCT_TYPE_FAILURE = 'ADD_PRODUCT_TYPE_FAILURE';

export const UPDATE_PRODUCT_TYPE_REQUEST = 'UPDATE_PRODUCT_TYPE_REQUEST';
export const UPDATE_PRODUCT_TYPE_SUCCESS = 'UPDATE_PRODUCT_TYPE_SUCCESS';
export const UPDATE_PRODUCT_TYPE_FAILURE = 'UPDATE_PRODUCT_TYPE_FAILURE';

export const DELETE_PRODUCT_TYPE_REQUEST = 'DELETE_PRODUCT_TYPE_REQUEST';
export const DELETE_PRODUCT_TYPE_SUCCESS = 'DELETE_PRODUCT_TYPE_SUCCESS';
export const DELETE_PRODUCT_TYPE_FAILURE = 'DELETE_PRODUCT_TYPE_FAILURE';

export const SET_PRODUCT_TYPE_EDIT = 'SET_PRODUCT_TYPE_EDIT';
export const CLEAR_PRODUCT_TYPE_EDIT = 'CLEAR_PRODUCT_TYPE_EDIT'; 